
































import { Component, Mixins } from "vue-property-decorator";
import { LinkMixin } from "@/mixins/LinkMixin";
import { AuthModule } from "@/store/auth.module";
import QuestionnaireDialog from "./AppQuestionnaire.vue";
import InfoQuestionaryFooter from "@/components/ui/InfoQuestionaryFooter.vue";

@Component({
  components: {
    QuestionnaireDialog,
    InfoQuestionaryFooter,
  },
})
export default class AppFooter extends Mixins(LinkMixin) {
  get text() {
    const text = this.$t("app-footer.text") as string;
    if (!this.$vuetify.breakpoint.smAndUp) {
      return text.replace(".", ". <br />");
    }
    return text;
  }
  get user() {
    return AuthModule.user as IUser;
  }
}
